/* global Parse */

import React, { Component } from 'react';
import { Grid, Image, Form, Segment, Input, Button, Message, Header } from 'semantic-ui-react';
import '../styles/Login.css';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      success: null,
      error: null
    };
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = e => {
    e.preventDefault();
    this.setState({success: null, error: null});

    const {email} = this.state;

    Parse.User.requestPasswordReset(email).then(() => {
      this.setState({success: 'Your request is being processed. Check your email for a link to reset your password.'});
    }).catch(err => {
      this.setState({error: err.message});
    });
  }

  render() {
    return (
      <Grid className='login-grid' verticalAlign="middle" textAlign="center">
        <Grid.Column>
          <Image src='/images/download.png' style={{marginBottom: '1.5em'}} />
          <Form size="large" success={!!this.state.success} error={!!this.state.error} onSubmit={this.handleSubmit}>
            <Segment stacked>
              <Header as='h2'textAlign='left'>Forgot your password?</Header>
              <Form.Field>
                <Input icon='mail' iconPosition='left' placeholder='Email' name='email' onChange={this.handleChange}/>
              </Form.Field>
              <Button type='submit' color="black" fluid content='Submit'/>
            </Segment>
            <Message success>
              <p style={{textAlign: 'left'}}>{this.state.success}</p>
            </Message>
            <Message error>
              <p style={{textAlign: 'left'}}>{this.state.error}</p>
            </Message>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}

export default Login;